module.exports = __webpack_public_path__ + "img/followempty.0da3b3b3.png";